import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Clock, CheckCircle2, Download } from 'lucide-react';
export function Hero() {
  return <section className="pt-32 pb-16 md:pt-40 md:pb-24 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto" data-id="element-101">
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-102">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="max-w-2xl" data-id="element-103">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-blue/10 text-brand-blue font-semibold text-sm mb-6" data-id="element-104">
            <span className="relative flex h-2 w-2" data-id="element-105">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-blue opacity-75" data-id="element-106"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-brand-blue" data-id="element-107"></span>
            </span>
            Para padres y profesores
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black leading-[1.1] mb-6" data-id="element-108">
            IA Fácil y Práctica: <br data-id="element-109" />
            <span className="text-brand-blue" data-id="element-110">
              El Manual de Supervivencia Educativa
            </span>
          </h1>

          <p className="text-lg md:text-xl text-brand-text mb-8 leading-relaxed" data-id="element-111">
            Domina la Inteligencia Artificial en 15 minutos y conviértete en el
            guía que tus hijos y alumnos necesitan, sin tecnicismos ni
            complicaciones.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-112">
            <a href="#precio" className="inline-flex justify-center items-center gap-2 bg-brand-orange hover:bg-brand-orangeHover text-white px-8 py-4 rounded-full font-bold text-lg transition-all transform hover:scale-[1.02] shadow-soft hover:shadow-soft-lg" data-id="element-113">
              ¡Quiero mi Guía y Empezar Hoy!
            </a>
            <div className="flex items-center justify-center gap-2 text-brand-muted text-sm font-medium px-4 py-2 bg-white/50 rounded-full" data-id="element-114">
              <Download size={18} data-id="element-115" />
              Descarga inmediata · PDF
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-6 text-sm font-medium text-brand-muted" data-id="element-116">
            <div className="flex items-center gap-1.5" data-id="element-117">
              <Clock size={18} className="text-brand-yellow" data-id="element-118" />
              Aprende en 15 min
            </div>
            <div className="flex items-center gap-1.5" data-id="element-119">
              <CheckCircle2 size={18} className="text-green-500" data-id="element-120" />
              Sin tecnicismos
            </div>
            <div className="flex items-center gap-1.5" data-id="element-121">
              <ShieldCheck size={18} className="text-brand-blue" data-id="element-122" />
              Pago seguro ($6.39 USD)
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative" data-id="element-123">
          <motion.div animate={{
          y: [-10, 10, -10]
        }} transition={{
          repeat: Infinity,
          duration: 6,
          ease: 'easeInOut'
        }} className="relative z-10 rounded-3xl overflow-hidden shadow-soft-lg border-8 border-white bg-white" data-id="element-124">
            <img src="https://cdn.magicpatterns.com/uploads/wZ8HY2C5Bk2nwdoh9LksRS/PortadaIA-Facil-y-Practica.png" alt="Familia aprendiendo IA juntos" className="w-full h-auto object-cover rounded-2xl" data-id="element-125" />
          </motion.div>

          {/* Decorative background blob */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-brand-yellow/20 rounded-full blur-3xl -z-10" data-id="element-126"></div>
        </motion.div>
      </div>
    </section>;
}